import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import { Field, Formik } from 'formik';
import reset from 'assets/icon/reset.svg';
import search from 'assets/icon/search.svg';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';

let hasDatePopupOpen = false;


let rowForEdit = {};
let updatedFields = {};

// const application = [
//     { applicationid: 101, applicationName: 'Contract Pharmacy', encryptedappid: "MjFnUDZITDUweWNqL3plcG9MVmZoZz09" }
// ]

const SearchContainer = (props) => {
    const { onSearch, onReset, Loading, selectedcoveredEntity, setFilterShow, startPage,
        setStartPage, setSelectedValues, setSort } = props;
    const {
        states: { configuration },
        setStates,
        resetStates,
    } = useContextService();

    const API = useAxios();
    const [data, setData] = useState([]);
    const [showDetails, setShowDetails] = useState(true)
    const [ceid, setceid] = useState()
    const [application, setApplication] = useState([])
    const [appid, setAppid] = useState("")
    const [reportType, setReportType] = useState([])
    const [reportid, setReportid] = useState()
    const [coveredEntityData, setCoveredEntityData] = useState([])
    const [focusedInput, setFocusedInput] = useState('');
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    const { searchTerms, } = configuration;
    const updateStates = (configuration) => {
        setStates('configuration', configuration);
    };


    useEffect(() =>{
        fetchAppType()
    },[])

    const fetchAppType = async () =>{
        try {
          const { data } = await API.get('api/Report/getAppType', {
            hasDefaultURL: true,
          }
        );
        if (data) {
          setApplication(data)
          setLoading(false)
        }
        }
        catch (error) {
          'failed to load data'
    
        }
      }

    const fetchCoveredEntities = async (id) => {
        setLoading(true)
        let ApiURL= ''
        if(id == "MjFnUDZITDUweWNqL3plcG9MVmZoZz09"){
          ApiURL =  'api/CP/configured'
        }
        if(id == "NTdoSnFwRHRCR3cyTE9iZ2hYOEVNdz09") {
           ApiURL =  'api/CP2/configured'
        }
        try {
            const { data } = await API.get(ApiURL
                , {
                    hasDefaultURL: true,
                }
            );
            setLoading(false)
            if (data) {
                setCoveredEntityData(data)
            }
        } catch (error) {
            'failed to load data'
            setLoading(false)
        }
    };
    useEffect(() => {
        if(appid){
            fetchCoveredEntities(appid);
            }
        // fetchPharmacy();
    }, [selectedcoveredEntity])

    const updateRowValue = (value, col) => {

        const tempRow = { ...rowForEdit };
        tempRow[col] = value;
        rowForEdit = tempRow;
    };

    useEffect(() => {
    }, [showDetails])

    const handleAppChange = (e) => {
        setceid('')
        setCoveredEntityData([]);
        setReportType('')
        setReportType([])
        const { value } = e.target;
        setAppid(value)
        if (value) {
            fetchCoveredEntities(value)
            fetchReportType(value)

        }
        else {
            setReportType([])

        }
    }
    const fetchReportType = async (appid) => {
        setLoading(true)
        try {
            const { data } = await API.get(`api/Report/types/${appid}`
                , {
                    hasDefaultURL: true,
                }
            );
            setReportType(data)

        } catch (error) {
            'failed to load data'
        }
    };
    const handleCeChange = (e) => {
        const { value } = e.target;
        setceid(value);
        //searchTerms.coveredEntityIDs=value
    };

    const handleReportChange = (e) => {
        const { value } = e.target;
        setReportid(value);
        //searchTerms.ReportTypeId=value
    }

    const handleFocus = (inputName) => {
        setFocusedInput(inputName);
    };

    const handleBlur = () => {
        setFocusedInput('');
    };

    const handleSubmit = async (val, actions,) => {
        let values = {};
       // values.ApplicationId = appid,
            values.coveredEntityID = ceid,
            values.ReportTypeId = reportid
        searchTerms.coveredEntityIDs = ceid
        searchTerms.ApplicationId = appid
        searchTerms.ReportTypeId = reportid
        configuration.search.currentPage = 1;
        configuration.search.order = 'desc'
        updateStates(configuration);
        if (appid == '' || appid == undefined || ceid == '' || ceid == undefined) {
            setError(true)
        }
        else {
            await onSearch(values);
            setError(false)
        }
        setFilterShow(false)
        setStartPage(2)
        setSelectedValues('')
        setSort(false)
    };

    const handleReset = () => {
        setceid("");
        setAppid("");
        setReportid("");
        setError(false);
        onReset();
        setSelectedValues('')
        configuration.search.pageSize = 10
        configuration.search.order = "desc"
        searchTerms.coveredEntityIDs = []
        searchTerms.ReportTypeId = []
        updateStates(configuration);
        resetStates('configuration');
    };

    return (

        <div>
            {/* {Loading&&<Loader opacity={0.01}color='black'/>}  */}
            <Formik
                initialValues={searchTerms}
                onSubmit={handleSubmit}
                onReset={handleReset}
                //    validationSchema={validationSchema}
                enableReinitialize={true}
                children={(props) => {
                    const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                    return (
                        <div>
                            <div >
                                <Row className='d-flex' style={{}}>
                                    <Col md={3} lg={3} sm={6} xs={6}  >
                                        {' '}
                                        <FormGroup>
                                            <Label
                                                htmlFor="Application" for='reportname'
                                                className={focusedInput === 'Application' ? 'label-focus' : 'required'}
                                            >Application <span>*</span></Label>
                                            <Field
                                                id='reportname'
                                                name='reportname'
                                                type='select'
                                                placeholder="(All)"
                                                value={appid}
                                                autoComplete='off'
                                                onChange={(e) => handleAppChange(e)}
                                                component={FormikSelectField}
                                                options={application}
                                                defaultoption="--select--"
                                                keys={{
                                                    id: 'encryptedAppId',
                                                    label: 'applicationType',
                                                }}

                                                onFocus={() => handleFocus('Application')}
                                                onBlur={handleBlur}
                                            >
                                                <option value="">{"-Select-"}</option>
                                            </Field>
                                            {(error) && (appid == '' || appid === undefined) && <div className="text-danger f-12">
                                                Application Id is required </div>}
                                        </FormGroup>
                                    </Col>

                                    <Col md={3} lg={3} sm={6} xs={6}  >
                                        {' '}
                                        <FormGroup>

                                            <Label
                                                htmlFor="CoveredEntity" for='reportname'
                                                className={focusedInput === 'CoveredEntity' ? 'label-focus' : 'required'}
                                            >Covered Entity /OPAID <span>*</span></Label>
                                            {/* <Input
                                                id='reportname'
                                                name='reportname'
                                                type='select'
                                                placeholder="(All)"
                                                autoComplete='off'
                                                onFocus={() => handleFocus('CoveredEntity')}
                                                onBlur={handleBlur}
                                            >
                                                <option value="">{"-Select-"}</option>
                                            </Input> */}
                                            <Field
                                                className="required"
                                                name='covereEntity'
                                                type='text'
                                                disabled={appid == ""}
                                                value={ceid}
                                                onChange={(e) => handleCeChange(e)}
                                                component={FormikSelectField}
                                                options={coveredEntityData}
                                                onFocus={() => handleFocus('CoveredEntity')}
                                                onBlur={handleBlur}
                                                defaultoption='--select--'
                                                keys={ appid  == 'MjFnUDZITDUweWNqL3plcG9MVmZoZz09' ?{
                                                    id: 'ceid',
                                                    label: 'ceName',
                                                  }:{
                                                  id: 'coveredEntityID',
                                                  label: 'coveredEntityName',
                                                  }}
                                                
                                            />
                                            {(error) && (ceid == '' || ceid === undefined) && <div className="text-danger f-12">
                                                Covered Entity name is required</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col md={3} lg={3} sm={6} xs={6}  >
                                        {' '}
                                        <FormGroup>
                                            <Label
                                                htmlFor="ReportType" for='reportname'
                                                className={focusedInput === 'ReportType' ? 'label-focus' : ''}
                                            >Report Type</Label>
                                            <Field
                                                name='ReportType'
                                                type='text'
                                                value={reportid}
                                                disabled={appid == ""}
                                                onChange={handleReportChange}
                                                component={FormikSelectField}
                                                options={reportType}
                                                onFocus={() => handleFocus('ReportType')}
                                                onBlur={handleBlur}
                                                defaultoption='--select--'
                                                keys={{
                                                    id: 'reportTypeID',
                                                    label: 'reportTypeName',
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                            <div className='section-devider-border mt-2 mb-3'></div>
                            <div hidden={""}>
                                <Row>
                                    <Col sm={0} className="d-flex" style={{ justifyContent: "flex-end" }}>
                                        <Label>{""}</Label>
                                        <Button
                                            // hidden={isAddPermission}
                                            // disabled={isSubmitting}
                                            color="primary"
                                            className="reset"
                                            onClick={handleReset}

                                        // disabled={!coveredEntityid}
                                        // hidden={!hasPermission("ADD")}
                                        >
                                            <span className='right_5'><img src={reset} alt="" /></span>
                                            Reset
                                        </Button>
                                        <Button
                                            // hidden={isAddPermission}
                                            // disabled={isSubmitting}
                                            color="primary"
                                            className="search"
                                            onClick={handleSubmit}

                                        // disabled={!coveredEntityid}
                                        // hidden={!hasPermission("ADD")}
                                        >
                                            <span className='right_5'> <img src={search} alt="" /></span>
                                            Search
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>);
                }}>
            </Formik>
        </div>
    )
}

export default SearchContainer